import React from "react";
import "../../styles/component-styles/footer.css"

const LongFooter = () => {
  return(
  <footer id="footer">
      <div>
        <h2>Eat, Cook, Repeat</h2>
        <p>Share Your Best Recipe By Uploading Here !</p>

        <div className="footer-link">
          <p>Copyright &copy; 2022 by Riyadh Ryan Albar. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default LongFooter;